import { render } from "./index.vue?vue&type=template&id=bd63741a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bd63741a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd63741a"],['__file',"src/vab/layouts/VabLayoutColumn/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd63741a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd63741a', __exports__)) {
    api.reload('bd63741a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bd63741a&scoped=true", () => {
    api.rerender('bd63741a', render)
  })

}


export default __exports__